<template>
  <div>
    <v-btn @click="addItem" class="btn-new-item" color="primary" outlined dense>
      <v-icon color="primary" size="14">mdi-plus</v-icon>

      <div class="text-none ml-2">Novo Vídeo</div>
    </v-btn>

    <template v-if="files.length">
      <div class="black--text text-body-2 font-weight-medium mt-4">
        {{ titleUpload }}
      </div>

      <div class="mx-n4">
        <v-list class="mt-2">
          <v-list-item
            class="list-item-file"
            v-for="(item, index) in files"
            :key="index"
          >
            <v-list-item-content class="grid-list grid-list-items">
              <TextFarmField v-model="item.title" title="Título" />

              <TextFarmField
                v-model="item.link"
                title="Link"
                placeholder="https://www.youtube.com/watch?v=id_do_video"
              />

              <v-btn
                @click.stop="removeFile(index)"
                color="transparent"
                depressed
                small
                fab
              >
                <v-icon color="red">mdi-delete-outline</v-icon>
              </v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </template>

    <v-divider v-if="items.length" class="my-4" />

    <template v-if="items.length > 0">
      <div class="d-flex align-center justify-space-between mt-4">
        <div class="black--text text-body-2 font-weight-medium">
          {{ titleUploaded }}
        </div>

        <div class="d-flex">
          <v-btn
            @click.prevent="checkAllUploaded()"
            color="#dbdee1"
            outlined
            small
          >
            <div class="black--text text-none">Selecionar tudo</div>
          </v-btn>

          <v-btn
            @click.prevent="toggleDelete"
            :disabled="!selectedUploadedFiles.length"
            class="ml-2"
            color="#e7000b"
            depressed
            small
          >
            <div class="white--text text-none">
              Excluir Selecionados
              {{
                selectedUploadedFiles.length > 0
                  ? `(${selectedUploadedFiles.length})`
                  : ""
              }}
            </div>
          </v-btn>
        </div>
      </div>

      <div class="mt-3 grid-list-files">
        <FileCardFarm
          v-for="(item, key) in mappedItems"
          @select="selectUploadedFile(item.id)"
          @delete="singleDelete(item.id)"
          @highlight="highlightFile(item.id)"
          :key="key + '-uploaded'"
          v-bind="item"
          :checked="selectedUploadedFiles.includes(item.id)"
          is-video-youtube
        />
      </div>
    </template>

    <v-dialog
      v-if="selectedUploadedFiles.length > 0 && dialogDelete"
      v-model="dialogDelete"
      max-width="500"
      persistent
    >
      <DeleteItemDialog
        @confirm="onDelete"
        @close="toggleDelete()"
        :loading="isLoadingDelete"
        :title="
          selectedUploadedFiles.length > 1 ? 'Apagar vídeos' : 'Apagar vídeo'
        "
        :name="
          selectedUploadedFiles.length > 1
            ? selectedUploadedFiles.length + ' vídeos selecionados'
            : 'esse vídeo'
        "
      />
    </v-dialog>
  </div>
</template>

<script>
import TextFarmField from "@/components/fields/farm/Text.vue";
import FileCardFarm from "@/components/cards/farm/File.vue";
import DeleteItemDialog from "@/components/dialogs/DeleteItem.vue";
import formatDate from "@/utils/formatDate";
import { mapActions } from "vuex";

export default {
  components: { TextFarmField, FileCardFarm, DeleteItemDialog },
  props: {
    title: String,
    table: String,
    helpText: String,
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    files: [
      {
        title: "",
        link: "",
      },
    ],
    isLoadingDelete: false,
    selectedUploadedFiles: [],
    dialogDelete: false,
  }),
  computed: {
    mappedItems() {
      return this.items.map(({ id, title, embed_url, created_at }) => ({
        id,
        name: title,
        url: embed_url,
        created_at,
      }));
    },
    titleUpload() {
      const count = (this.files || []).filter((item) => item.link).length;

      return "Links adicionados" + (count ? ` (${count})` : "");
    },
    titleUploaded() {
      return (
        "Links cadastrados" +
        (this.items?.length > 0 ? ` (${this.items.length})` : "")
      );
    },
  },
  methods: {
    ...mapActions("properties", ["destroyFiles"]),
    async onDelete() {
      if (
        !this.selectedUploadedFiles ||
        this.selectedUploadedFiles.length === 0
      )
        return;

      this.isLoadingDelete = true;
      const files = [...this.selectedUploadedFiles]; // Cópia do array

      try {
        const params = {
          type: this.table,
          ids: files,
        };

        const r = await this.destroyFiles(params);

        if (r) {
          this.$eventHub.$emit("snackBar", {
            icon: "mdi-check-circle",
            message: `${files.length} arquivos excluídos com sucesso.`,
            type: "success",
          });

          this.$emit("delete-files", params);

          this.selectedUploadedFiles = [];
          this.dialogDelete = false;
        }
      } catch (error) {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-delete-alert",
          message: "Erro ao excluir os arquivos selecionados. Tente novamente.",
          type: "error",
        });
      } finally {
        this.isLoadingDelete = false;
      }
    },
    parseSelectedFiles() {
      return this.items.filter(({ id }) =>
        this.selectedUploadedFiles.includes(id),
      );
    },
    checkAllUploaded() {
      if (this.selectedUploadedFiles.length === this.items.length) {
        this.selectedUploadedFiles = [];
      } else {
        this.selectedUploadedFiles = this.items.map(({ id }) => {
          return id;
        });
      }
    },
    removeFile(index) {
      this.files.splice(index, 1);
      if (this.files.length === 0) {
        this.addItem();
      }

      this.$emit("input", this.files);
    },
    addItem() {
      this.files.push({
        title: "",
        link: "",
      });
    },
    selectUploadedFile(id) {
      if (!this.selectedUploadedFiles.includes(id)) {
        this.selectedUploadedFiles.push(id);
      } else {
        this.selectedUploadedFiles = this.selectedUploadedFiles.filter(
          (item) => item !== id,
        );
      }
    },
    singleDelete(id) {
      this.selectedUploadedFiles = [];
      this.selectedUploadedFiles.push(id);

      this.toggleDelete();
    },
    toggleDelete() {
      this.dialogDelete = !this.dialogDelete;
    },
    formatDate,
  },
  watch: {
    files: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-new-item {
  border: 1px dashed rgba(16, 120, 35, 0.3) !important;
  position: absolute;
  right: 24px;
  top: 18px;
}

.list-item-file {
  background-color: transparent;
  border-radius: 8px;
  transition: all 0.1s linear;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
}

.grid-list {
  display: grid;
  gap: 12px;
}

.grid-list-items {
  $columns: 3;
  $gap: 12px;

  align-items: flex-end;
  display: grid;
  gap: $gap;
  grid-template-columns: 35% auto 40px;

  > * {
    margin-bottom: 0 !important;
  }
}

.grid-list-files {
  $columns: 4;
  $gap: 12px;

  display: grid;
  gap: $gap;
  grid-template-columns: repeat(
    $columns,
    calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
  );
}
</style>
